const FutureContractsHeaderExpiryStateEnum = {
    Undefined : 0,
    DueDate : 1,
    CountDown : 2
}
export default FutureContractsHeaderExpiryStateEnum;